import {Component, OnInit, ViewChild} from "@angular/core";
import {ActivatedRoute, Router} from "@angular/router";
import {RoleService} from "../../services/role.service";
import {AnnualFeeDeductionService} from "../services/annual-fee-deduction.service";
import {ProductService} from "../services/product.service";
import {MatTableGeneratorComponent} from "../../shared/mat-table-generator/mat-table-generator.component";
import {MultiCrudDataSource} from "../../table-datasouces/multi-crud.datasource";
import {toDateTimeStringNoSeconds} from "../../providers/app-date-adapter";
import {ContentRowField} from "../../shared/content-row/content-row.component";
import {AnnualFeeDeduction, MicroPaymentSession} from "../../dto/invoice";
import {MicroPaymentService} from "../services/micro-payment.service";

@Component({
  selector: 'app-micro-payment',
  templateUrl: './micro-payment.component.html',
  styleUrls: ['./micro-payment.component.css']
})
export class MicroPaymentComponent implements OnInit {

  constructor(
      private route: ActivatedRoute,
      private router: Router,
      private roleService: RoleService,

      public microPaymentService: MicroPaymentService,
      private productService: ProductService,) { }


  @ViewChild(MatTableGeneratorComponent, {static: true}) table: MatTableGeneratorComponent;

  ngOnInit(): void {
  }


  dataSource = new MultiCrudDataSource(this.microPaymentService);
  columns = [

    {
      columnDef: 'date',
      header: 'Date',
      cell: row => `${toDateTimeStringNoSeconds(row.createDate) || ''}`
    },
    {columnDef: 'payText', header: 'Reference', cell: row => `${row.payText}`},

    //{columnDef: 'amount', header: 'Amount', cell: row => `${row.amount}`},
    //{columnDef: 'paidAmount', header: 'Paid Amount', cell: row => `${row.paidAmount}`},


  ] as ContentRowField<MicroPaymentSession>[];
  customActions: any[] = [];


  editEnabled() {
    return false;
  }

  deleteEnabled() {
    return false;
  }

  getRowClass = (item: AnnualFeeDeduction): string => '';

  getViewLink = (item: AnnualFeeDeduction): string => item.id.toString();

  getEditLink = (item: AnnualFeeDeduction): string => item.id.toString() + '/edit';

}
